import React from 'react';
import { useLoaderData } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { AppRouter } from '@/routes/AppRouter';
import { useOrgStore } from '@/stores/orgStore';

type User = {
  id: string;
  email: string;
  fullName: string;
  isEmailVerified: boolean;
  isSuperAdmin: boolean;
};

type BootstrapData = {
  user?: User;
  orgs?: any[];
  activeOrgId?: string | null;
  featureFlags?: any;
};

export function ProtectedApp() {
  const bootstrapData = useLoaderData() as BootstrapData | undefined;

  // Hydrate stores synchronously before the first render so that guards
  // (e.g. SuperAdminGuard) can read the correct user/org state immediately
  // instead of waiting for a useEffect that fires *after* the initial render.
  const hydratedRef = React.useRef(false);
  if (!hydratedRef.current && bootstrapData) {
    hydratedRef.current = true;

    if (bootstrapData.user) {
      const current = useAuthStore.getState().user;
      if (!current || current.id !== bootstrapData.user.id) {
        useAuthStore.setState({ user: bootstrapData.user });
      }
    }

    if (bootstrapData.orgs !== undefined) {
      const activeOrgId = bootstrapData.activeOrgId || null;
      useOrgStore.setState({
        orgs: bootstrapData.orgs,
        activeOrgId,
        initialized: true,
        isLoading: false,
        error: null,
      });
      if (activeOrgId) {
        try {
          localStorage.setItem('ima_active_org_id', activeOrgId);
        } catch {}
      }
    }
  }

  return <AppRouter />;
}


